export const ApiToken = {
    // !测试站点
    // flag: false,
    // token: 'UpToken',
    // baseUrl: 'https://events.schneider-electric.cn/ciif2025_dev/Api',
    // baseApi: '',
    // shareUrl: 'https://events.schneider-electric.cn/ciif2025_dev',
    // UrlBase: '',
    // Url: '',
    // surveyTime: '2023-08-25 09: 00: 00',
    // Cpath: '/ciif2025_dev/',

    // !正式站点
    flag: true,
    token: 'UpTokenCase',
    baseUrl: 'https://events.schneider-electric.cn/ciif2025/Api', //正式
    baseApi: '',
    shareUrl: 'https://events.schneider-electric.cn/ciif2025',
    UrlBase: '',
    Url: '',
    surveyTime: '2023-09-19 09: 00: 00',
    Cpath: '/ciif2025/'
}

// export const Res_Url = 'https://events.schneider-electric.cn/ciif2025_dev/2025'
export const Res_Url = 'https://staticdn.ht-s.cn/se/ciif/2025' //正式的